// PanelUser Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Avatar from '../../common/avatar/avatar.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import Input from '../../common/input/input.jsx'

class PanelUser extends Component {
  constructor (props) {
    super(props)

    this._references = {
      assigneePopover: React.createRef()
    }

    this.state = {
      isFocus: false
    }
  }

  static get propTypes () {
    return {
      users: PropTypes.array,
      onCheck: PropTypes.func,
      keyword: PropTypes.string,
      onSearchUser: PropTypes.func,
      onDeleteUser: PropTypes.func,
      onShowPopup: PropTypes.func,
      showSearch: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      users: [],
      onCheck: null,
      keyword: '',
      onSearchUser: null,
      onDeleteUser: null,
      onShowPopup: null,
      showSearch: true
    }
  }

  _onShowPopup (user, userIndex) {
    const { onShowPopup } = this.props
    if (onShowPopup) {
      onShowPopup(user, userIndex, this._references.assigneePopover.current)
    }
  }

  _onFoucsField () {
    this.setState({ isFocus: true })
  }

  _onBlurField () {
    this.setState({ isFocus: false })
  }

  render () {
    const { users, onCheck, keyword, onSearchUser, showSearch } = this.props
    const { isFocus } = this.state

    return (
      <div className='panel-user' ref={this._references.assigneePopover}>
        <div className='userlist'>
          {users.map((user, idx) => (
            <div className='useritem' key={idx}>
              {user.checked ? (
                <span
                  className='iconselect checked'
                  onClick={(ev) =>
                    onCheck ? onCheck(user.id, !user.checked, ev) : null}
                >
                  <span className='icon checked' />
                </span>
              ) : (
                <span
                  className={`iconselect iconselect_${user.scheduleType}`}
                  onClick={(ev) =>
                    onCheck ? onCheck(user.id, !user.checked, ev) : null}
                >
                  <span className='icon' />
                </span>
              )}
              <Avatar imageUrl={user.imageUrl} />
              <span className='title'>{user.displayName}</span>
              <IconButton
                icon='planner'
                type='secondary'
                canHover
                className='userpopup'
                onClick={this._onShowPopup.bind(this, user, idx)}
              />
            </div>
          ))}
        </div>
        <div className='usersearchform'>
          {showSearch && (
            <div className='searchfield'>
              <Input
                placeholder='plannerv2.task.searchAssignee'
                name='keyword'
                type='text'
                maxLength={128}
                styleType='filterinput'
                value={keyword}
                onChange={onSearchUser}
                className={isFocus ? 'editable' : ''}
                onFocus={this._onFoucsField.bind(this)}
                onBlur={this._onBlurField.bind(this)}
              />
              <IconButton
                icon='x'
                type='error'
                className='action'
                onClick={(ev) => onSearchUser && onSearchUser('', ev)}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default PanelUser
